import {
  CheckTRTCUserStatus,
  GetFrontKeyVal,
  IsTrtcUser,
} from '@src/utils/api/trtc-api';
import { create } from 'zustand';
// import { CheckTRTCUserStatus, GetFrontKeyVal, IsTrtcUser } from '@src/submodule/apis/trtc-api';
export const AMERICA_LIMIT_MODAL_SHOWN = 'america_limite_modal_shown';

interface AmericaLimitState {
  isTRTCUser: boolean | undefined;
  setIsTRTCUser: (isTRTCUser: boolean) => void;

  isNewUserAtFirstSession: boolean | undefined;
  setIsNewUserAtFirstSession: (v: boolean) => void;

  isAmericaUser: boolean | undefined;
  setIsAmericaUser: (isAmericaUser: boolean) => void;

  isCreateAppRegularOpend: boolean | undefined;
  isOnceRegularOpend: boolean | undefined;

  hasChosenRegular: boolean | undefined;
  setHasChosenRegular: (hasChosenRegular: boolean) => void;

  hasChosenNewUserRegular: boolean | undefined;
  setHasChosenNewUserRegular: (hasChosenNewUserRegular: boolean) => void;

  postPayWhite: { IsPostPay: any; IsProtected: any };
  setPostPayWhite: (postPayWhite: { IsPostPay: any; IsProtected: any }) => void;

  allPkgs: any[] | undefined;
  setAllPkgs: (allPkgs: any[]) => void;

  hasUsefulLicenseProducts: any[];
  setHasUsefulLicenseProducts: (allPkgs: any[]) => void;

  fetchIsTRTCUser: () => Promise<void>;
  fetchAmericaRegular: () => Promise<void>;
  fetchHasChosenRegular: () => Promise<void>;
}

export const useTrtcStore = create<AmericaLimitState>((set, get) => ({
  isTRTCUser: undefined,
  setIsTRTCUser: (isTRTCUser: boolean) => set({ isTRTCUser }),

  isNewUserAtFirstSession: undefined,
  setIsNewUserAtFirstSession: (isNewUserAtFirstSession: boolean) => set({ isNewUserAtFirstSession }),

  isAmericaUser: undefined,
  setIsAmericaUser: (isAmericaUser: boolean) => set({ isAmericaUser }),

  isCreateAppRegularOpend: undefined,
  isOnceRegularOpend: undefined,

  hasChosenRegular: undefined,
  setHasChosenRegular: (hasChosenRegular: boolean) => set({ hasChosenRegular }),

  hasChosenNewUserRegular: undefined,
  setHasChosenNewUserRegular: (hasChosenNewUserRegular: boolean) =>
    set({ hasChosenNewUserRegular }),

  postPayWhite: { IsPostPay: undefined, IsProtected: undefined },
  setPostPayWhite: (postPayWhite: {
    IsPostPay: boolean;
    IsProtected: boolean;
  }) => set({ postPayWhite }),

  allPkgs: undefined,
  setAllPkgs: (allPkgs: any[]) => set({ allPkgs }),

  hasUsefulLicenseProducts: [],
  setHasUsefulLicenseProducts: (hasUsefulLicenseProducts: any[]) => set({ hasUsefulLicenseProducts }),

  fetchIsTRTCUser: async () => {
    try {
      const { isTRTCUser } = get();
      if (isTRTCUser !== undefined) return;

      const data: { IsTrtcUser: number } = await IsTrtcUser();
      set({ isTRTCUser: Number(data.IsTrtcUser) !== 0 });
    } catch (e) {
      set({ isTRTCUser: false });
    }
  },

  fetchAmericaRegular: async () => {
    const { isAmericaUser, isCreateAppRegularOpend, isOnceRegularOpend } =
      get();
    if (
      isAmericaUser !== undefined &&
      isCreateAppRegularOpend !== undefined &&
      isOnceRegularOpend !== undefined
    )
      return;

    try {
      const { CountryName, NeedSignAgreementUserTypeForUs } =
        await CheckTRTCUserStatus();
      const isAmericaUser = CountryName === 'US';
      const _isCreateAppRegularOpend =
        NeedSignAgreementUserTypeForUs?.includes('new');
      const _isOnceRegularOpend =
        NeedSignAgreementUserTypeForUs?.includes('old');

      set({
        isAmericaUser,
        isCreateAppRegularOpend: _isCreateAppRegularOpend,
        isOnceRegularOpend: _isOnceRegularOpend,
      });
    } catch (e) {
      set({ isCreateAppRegularOpend: false, isOnceRegularOpend: false });
    }
  },

  fetchHasChosenRegular: async () => {
    const { hasChosenRegular } = get();
    if (hasChosenRegular !== undefined) return;

    try {
      const { Val } = await GetFrontKeyVal({ Key: AMERICA_LIMIT_MODAL_SHOWN });
      set({ hasChosenRegular: Val === 'true' });
    } catch (e) {
      set({ hasChosenRegular: false });
    }
  },
}));
